export default "__VITE_ASSET__DnsE7XsB__"